import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from "../../../middlewares/api/actions";
import { getMappedTree } from "../../../utils/tree";
import { getCubesTree } from "../../../utils/treeBuilders";
import { BACKUP_RESTORE_CUBE_CREATE_BACKUP, BACKUP_RESTORE_CUBE_DELETE_BACKUP, BACKUP_RESTORE_CUBE_RESTORE, BACKUP_RESTORE_CUBE_SELECTED, BACKUP_RESTORE_CUBE_TREE_READ } from "./actions";

const cubeBackupRestoreReducer = (state = {
    cubeList:null,
    selectedCube: null
}, action) => {
    switch (action.type) {
        case BACKUP_RESTORE_CUBE_SELECTED:
            return {
                ...state,
                selectedCube: action.cube
            }
        case REQUEST_START:
            
            switch (action.label) {
                case BACKUP_RESTORE_CUBE_TREE_READ:
                    return {
                        ...state,
                    }
                case BACKUP_RESTORE_CUBE_CREATE_BACKUP:
                    return {
                        ...state,
                    }
                case BACKUP_RESTORE_CUBE_RESTORE:
                    return {
                        ...state,
                    }
                case BACKUP_RESTORE_CUBE_DELETE_BACKUP:
                    return {
                        ...state
                    }
                default:
                    return {...state}
            }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case BACKUP_RESTORE_CUBE_TREE_READ:
                    const [allCubes, dcs] = action.response;
                    const treeCubes = getCubesTree(allCubes, dcs)
                    const treeWithCategoriesOrd = getMappedTree(treeCubes, "children", node => {
                        let ordCount = 1;
                        return {
                          ...node,
                          TreeID: node.CatCode ? `Cat_${node.CatCode}` : `${node.Code}`,
                          children:
                            node.children
                              ? node.children
                                .sort((a, b) => {
                                  if (a.Ord !== undefined && b.Ord !== undefined) {
                                    return a.Ord - b.Ord;
                                  } else if (a.Ord !== undefined) {
                                    return a;
                                  } else if (b.Ord !== undefined) {
                                    return b;
                                  } else {
                                    return (a.CatCode || -1) - (b.CatCode || -1);
                                  }
                                })
                                .map(c => ({
                                  ...c,
                                  Ord: c.Ord !== undefined ? String(ordCount++) : undefined
                                }))
                              : node.children
                        };
                      });
                    return {
                        ...state,
                        cubeList: treeWithCategoriesOrd
                    }
                case BACKUP_RESTORE_CUBE_CREATE_BACKUP:
                    return {
                        ...state,
                        cubeList:null,
                        selectedCube:null
                    }
                case BACKUP_RESTORE_CUBE_RESTORE:
                    return {
                        ...state,
                        cubeList:null,
                        selectedCube:null
                    }
                case BACKUP_RESTORE_CUBE_DELETE_BACKUP:
                    return {
                        ...state,
                        cubeList:null,
                        selectedCube:null
                    }
                default:
                    return {...state}
            }
        case REQUEST_ERROR:
            switch (action.label) {
                case BACKUP_RESTORE_CUBE_TREE_READ:
                    return {
                        ...state,
                    }
                case BACKUP_RESTORE_CUBE_CREATE_BACKUP:
                    return {
                        ...state
                    }
                case BACKUP_RESTORE_CUBE_RESTORE:
                    return {
                        ...state,
                    }
                case BACKUP_RESTORE_CUBE_DELETE_BACKUP:
                    return {
                        ...state
                    }
                default:
                    return {...state}
            }
        default:
            return {
                ...state
            }
    }
}

export default cubeBackupRestoreReducer;